import { useEffect, useState } from "react";
import { Select } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { fetchAssetsTypes } from "services/assets-types.service";
import { AssetsTypesEntity } from "types/Asset";

const AssetsTypesSelect = ({
  value,
  onChange,
  isRequired,
}: {
  value?: string;
  onChange?: any;
  isRequired?: boolean;
}) => {
  const { t } = useTranslation();
  const [collection, setCollection] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { companyId } = useParams();

  const handleChange = (selectedValue: string) => {
    onChange(selectedValue);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        const collection = companyId ? await fetchAssetsTypes(companyId) : [];
        const dataCollection = collection.map((row: AssetsTypesEntity) => ({
          label: row.title,
          value: row.id,
        }));
        dataCollection.unshift({ label: " - ", value: "" });
        setCollection(dataCollection);
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
    fetchData();
  }, [companyId]);

  return (
    <div>
      <Select
        label={t("assets_types_select")}
        options={collection}
        onChange={handleChange}
        value={value}
        disabled={isLoading}
        requiredIndicator={isRequired ? true : false}
        error={isRequired && !value ? t("asset_type_is_required") : ""}
      />
    </div>
  );
};

export default AssetsTypesSelect;
